import { RootState } from 'types';

export const isAuthSelector = (state: RootState) => state.app.isAuth;
export const newPatient = (state: RootState) => state.register;
export const cpapInstructions = (state: RootState) => state.cpapInstructions;
export const consultationHistory = (state: RootState) => state.consultationHistory;
export const updateItem = (state: RootState) => state.updateItem;
export const medicalInstitution = (state: RootState) => state.medicalInstitution;
export const billingSelectors = (state: RootState) => state.billingStore;
export const billListSelectors = (state: RootState) => state.billingList;
export const payoutSelectors = (state: RootState) => state.payoutSlice;
export const workSpaceSelectors = (state: RootState) => state.workSpaces;
